var Backbone, EmailFormRecaptchaView,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

EmailFormRecaptchaView = (function(superClass) {
  extend(EmailFormRecaptchaView, superClass);

  function EmailFormRecaptchaView() {
    return EmailFormRecaptchaView.__super__.constructor.apply(this, arguments);
  }

  EmailFormRecaptchaView.prototype.initialize = function(options) {
    this.recaptcha_site_key = Groupon.Utils.getConfigFromDom().recaptcha_site_key;
    this.recaptchaId = "email_form_recaptcha";
    this.elementID = "#" + this.recaptchaId;
    this.options = options || {};
    this.model = this.options.model;
    this.I18nScope = 'modules.support';
    this.isFlexibleStepThree = this.options.isFlexibleStepThree;
    this.template = this.options.template;
    return this.isInputCompulsory = (this.recaptcha_site_key != null) && this.model.required === true || this.model.required === "true";
  };

  EmailFormRecaptchaView.prototype.render = function() {
    this.$el.html(toHtml(this.template, this.toHash()));
    return this.captchaObj = grecaptcha.render(this.getInputHtmlElement().get(0), {
      'sitekey': this.recaptcha_site_key,
      'callback': (function(_this) {
        return function() {
          return _this.validate();
        };
      })(this),
      'expired-callback': (function(_this) {
        return function() {
          return _this.validate();
        };
      })(this)
    });
  };

  EmailFormRecaptchaView.prototype.getInputHtmlElement = function() {
    return this.$el.find(this.elementID);
  };

  EmailFormRecaptchaView.prototype.getElementFromDom = function() {
    return $(this.elementID);
  };

  EmailFormRecaptchaView.prototype.toHash = function() {
    return {
      recaptchaId: this.recaptchaId,
      site_key: this.recaptcha_site_key,
      required: this.isInputCompulsory,
      counter: this.model.counter,
      stepThreeType: this.isFlexibleStepThree ? 'flexibleStepThree' : 'defaultStepThree',
      recaptcha_template: true
    };
  };

  EmailFormRecaptchaView.prototype.isInputGiven = function() {
    return this.isInputValid();
  };

  EmailFormRecaptchaView.prototype.readInput = function() {
    if (this.getElementFromDom().length > 0 && (this.captchaObj != null)) {
      return grecaptcha.getResponse(this.captchaObj);
    } else {
      return "";
    }
  };

  EmailFormRecaptchaView.prototype.isInputValid = function() {
    if (this.isInputCompulsory) {
      return this.readInput().length > 0;
    }
    return true;
  };

  EmailFormRecaptchaView.prototype.validate = function() {
    return this.options.validateEmailForm();
  };

  EmailFormRecaptchaView.prototype.populateInput = function(data) {
    data["g-recaptcha-response"] = this.readInput();
    return data;
  };

  return EmailFormRecaptchaView;

})(Backbone.View);

module.exports = EmailFormRecaptchaView;

//# sourceMappingURL=data:application/json;base64,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
